var Backbone, EmailFormRecaptchaView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormRecaptchaView = (function(superClass) {
  extend(EmailFormRecaptchaView, superClass);

  function EmailFormRecaptchaView() {
    return EmailFormRecaptchaView.__super__.constructor.apply(this, arguments);
  }

  EmailFormRecaptchaView.prototype.initialize = function(options) {
    this.recaptcha_site_key = Groupon.Utils.getConfigFromDom().recaptcha_site_key;
    this.recaptchaId = "email_form_recaptcha";
    this.elementID = "#" + this.recaptchaId;
    this.options = options || {};
    this.model = this.options.model;
    this.I18nScope = 'modules.support';
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.template = this.options.template;
    return this.isInputCompulsory = (this.recaptcha_site_key != null) && this.model.required === true || this.model.required === "true";
  };

  EmailFormRecaptchaView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    return this.captchaObj = grecaptcha.render(this.getInputHtmlElement().get(0), {
      'sitekey': this.recaptcha_site_key,
      'callback': (function(_this) {
        return function() {
          return _this.validate();
        };
      })(this),
      'expired-callback': (function(_this) {
        return function() {
          return _this.validate();
        };
      })(this)
    });
  };

  EmailFormRecaptchaView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormRecaptchaView.prototype.getElementFromDom = function() {
    return $(this.elementID);
  };

  EmailFormRecaptchaView.prototype.toHash = function() {
    return {
      recaptchaId: this.recaptchaId,
      site_key: this.recaptcha_site_key,
      required: this.isInputCompulsory,
      counter: this.model.counter,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      recaptcha_template: true
    };
  };

  EmailFormRecaptchaView.prototype.isInputGiven = function() {
    return this.isInputValid();
  };

  EmailFormRecaptchaView.prototype.readInput = function() {
    if (this.getElementFromDom().length > 0 && (this.captchaObj != null)) {
      return grecaptcha.getResponse(this.captchaObj);
    } else {
      return "";
    }
  };

  EmailFormRecaptchaView.prototype.isInputValid = function() {
    if (this.isInputCompulsory) {
      return this.readInput().length > 0;
    }
    return true;
  };

  EmailFormRecaptchaView.prototype.validate = function() {
    return this.options.validateEmailForm();
  };

  EmailFormRecaptchaView.prototype.populateInput = function(data) {
    data["g-recaptcha-response"] = this.readInput();
    return data;
  };

  return EmailFormRecaptchaView;

})(Backbone.View);

module.exports = EmailFormRecaptchaView;

//# sourceMappingURL=data:application/json;base64,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
